export const useGetQuoteItemsCartDataQueryKey = [
    'useGetQuoteItemsV2Cart',
    'regular',
    {collectTax: false},
];
